import { Component, OnInit } from '@angular/core';
import { DataserviceService } from '../../services/dataservice.service';

@Component({
  selector: 'app-left-side',
  templateUrl: './left-side.component.html',
  styleUrls: ['./left-side.component.scss']
})
export class LeftSideComponent implements OnInit {
  dataInput = ['example 1.wav', 'example 2.wav', 'example 3.wav', 'example 4.wav', 'example 5.wav', 'sample 6.wav'];
  audio: any;
  static: any;
  value: any;
  audioIndex = [3000, 16000, 6000, 12000, 12000, 9000];
  constructor(private dataservice: DataserviceService) { }

  ngOnInit() {
    this.audio = new Audio();
    this.audio.loop = false;
    for(let i = 0; i < this.dataInput.length; i++) {
      this.audio.src = './assets/' + this.dataInput[i];
    }
    this.audio.load();
    this.static = true;
  }
  sendIndex(i, data) {
    this.value = i;
    this.audio.src = './assets/' + data;
    this.audio.play();
    if (this.static === true) {
      this.dataservice.message.emit(({value: 9, loader: true}));
      setTimeout( () => {
        this.dataservice.message.emit({value: i, loader: false});
      }, this.audioIndex[i]);
    } else if (this.static === false) {
      this.dataservice.tradingNote(this.value).subscribe( (response) => {
        console.log(response);
      },
        (error) => {
        console.log(error);
        });
    }
  }
}
